import { Form, Grid } from "antd";
import { useForm } from "antd/es/form/Form";
import { useJourneyListingContext } from "../../context/JourneyListingContext";
import { ONEWAY_SORTERS } from "src/Modules/Flights/constants";
import { useDebounceFn } from "src/hooks/useDebounce";
import { FC, useState } from "react";
import { INITIAL_SORTER_VALUE } from "src/Modules/Flights/constants/JourneyListing";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import Sortersweb from "./layouts/SortersBar.web";
import SortersMob from "./layouts/SortersBar.mob";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { track } from "@amplitude/analytics-browser";

const SortersComponent = withConditionalComponent(Sortersweb, SortersMob);

const SortersBar: FC<{ dataGroups: any }> = ({ dataGroups }) => {
  const [form] = useForm();
  const { sorterState, isFetching } = useJourneyListingContext();
  const [, setSorters] = sorterState;
  const [activeSorter, setActiveSorter] = useState<string>(Object.keys(INITIAL_SORTER_VALUE)?.[0]);
  const activeValue = form.getFieldValue(activeSorter);
  const debouncedUpdateFilters = useDebounceFn(setSorters, 200);

  const handleChange = (value: any) => {
    const key = Object.keys(value)?.[0];
    setActiveSorter(key);
    debouncedUpdateFilters(value);
    track("Sorter Updated",{
      ...value
    })
  };
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  return (
    <Form className="flex" onValuesChange={handleChange} form={form} initialValues={INITIAL_SORTER_VALUE}>
      <SortersComponent
        trigger={isLargeScreen}
        props={{
          dataGroups,
          sorters: ONEWAY_SORTERS,
          activeSorter,
          activeValue,
          className: "md:px-2! md:p-1!",
          isLoading: isFetching,
        }}
      />
    </Form>
  );
};

export default SortersBar;
